import { render, staticRenderFns } from "./SButton.vue?vue&type=template&id=49611756&scoped=true&lang=html"
import script from "./SButton.vue?vue&type=script&lang=js"
export * from "./SButton.vue?vue&type=script&lang=js"
import style0 from "./SButton.vue?vue&type=style&index=0&id=49611756&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49611756",
  null
  
)

export default component.exports